// Total number of people for each event
export const eventIdToTotalPeople = {
  333: 140090,
  222: 88152,
  pyram: 57084,
  skewb: 31426,
  "333oh": 30525,
  444: 28669,
  555: 13933,
  minx: 9596,
  sq1: 8807,
  clock: 5924,
  666: 5774,
  magic: 4641,
  777: 4596,
  "333fm": 2682,
  "333ft": 2386,
  mmagic: 2039,
  "333bf": 1860,
  "444bf": 151,
  "555bf": 54,
};

export const eventIdToDisplayName = {
  222: "2x2x2 Cube",
  333: "3x3x3 Cube",
  "333bf": "3x3x3 Blindfolded",
  "333fm": "3x3x3 Fewest Moves",
  "333ft": "3x3x3 With Feet",
  "333mbf": "3x3x3 Multi-Blind",
  "333mbo": "3x3x3 Multi-Blind Old Style",
  "333oh": "3x3x3 One-Handed",
  444: "4x4x4 Cube",
  "444bf": "4x4x4 Blindfolded",
  555: "5x5x5 Cube",
  "555bf": "5x5x5 Blindfolded",
  666: "6x6x6 Cube",
  777: "7x7x7 Cube",
  clock: "Clock",
  magic: "Magic",
  minx: "Megaminx",
  mmagic: "Master Magic",
  pyram: "Pyraminx",
  skewb: "Skewb",
  sq1: "Square-1",
};
